import { getUniqueString as e } from "../../common/utils/index.js";
import { n as t } from "../../mode_constants-tb7TL85q.js";
import { TOOLTIP_DIRECTIONS as n } from "../tooltip/tooltip-constants.js";
import r from "../tooltip/tooltip.js";
import { createApp as i, h as a } from "vue";
import o from "deep-equal";
//#region directives/tooltip_directive/tooltip.js
var s = {
	name: "dt-tooltip-directive",
	install(s) {
		if (!globalThis.__DtTooltipDirectiveApp) {
			let e = i({
				name: "DtTooltipDirectiveApp",
				components: { DtTooltip: r },
				data() {
					return { tooltips: [] };
				},
				mounted() {
					globalThis.__DtTooltipDirectiveApp = this;
				},
				methods: {
					addOrUpdateTooltip(e, t) {
						let n = this.tooltips.findIndex((t) => t.id === e);
						n === -1 ? this.tooltips.push({
							id: e,
							...t
						}) : this.tooltips.splice(n, 1, {
							id: e,
							...t
						});
					},
					removeTooltip(e) {
						this.tooltips = this.tooltips.filter((t) => t.id !== e);
					}
				},
				render() {
					return a("div", this.tooltips.map(({ id: e, anchorElement: t, ...n }) => a(r, {
						key: e,
						...n,
						sticky: n.sticky === void 0 ? !0 : n.sticky,
						delay: n.delay === void 0 ? process.env.NODE_ENV !== "test" : n.delay,
						externalAnchorElement: t
					})));
				}
			}), t = document.createElement("div");
			document.body.appendChild(t), e.mount(t);
		}
		let c = globalThis.__DtTooltipDirectiveApp;
		s.directive("dt-tooltip", {
			beforeMount(e, t) {
				l(e, t);
			},
			updated(e, t) {
				o(t.value, t.oldValue) || l(e, t);
			},
			unmounted(e) {
				c.removeTooltip(e.getAttribute("data-dt-tooltip-id"));
			}
		});
		function l(r, i) {
			if (i.value === null || i.value === void 0) {
				let e = r.getAttribute("data-dt-tooltip-id");
				e && c.removeTooltip(e);
				return;
			}
			let a = r.getAttribute("data-dt-tooltip-id") || e(), o;
			if (typeof i.value == "string") o = {
				message: i.value,
				placement: i.arg || "top"
			};
			else if (typeof i.value == "object" && i.value !== null) o = {
				placement: i.arg || i.value.placement || "top",
				...i.value
			};
			else {
				console.error("DtTooltipDirective: binding value must be string, object, null or undefined");
				return;
			}
			Object.keys(i.modifiers).forEach((e) => {
				switch (e) {
					case "inverted":
						o.inverted = !0;
						break;
					case "no-delay":
						o.delay = !1;
						break;
					case "no-transition":
						o.transition = !1;
						break;
					default:
						t.includes(e) ? o.contentMode = e : n.includes(e) && (o.placement = e);
						break;
				}
			}), o.anchorElement = r, r.setAttribute("data-dt-tooltip-id", a), c.addOrUpdateTooltip(a, o);
		}
	}
};
//#endregion
export { s as DtTooltipDirective, s as default };

//# sourceMappingURL=tooltip.js.map